import React from 'react'
import {NavLink} from 'react-router-dom'
import './components.css'
import { CalendarRange } from 'lucide-react';
import { CalendarPlus } from 'lucide-react';
import { Search } from 'lucide-react';

export const NavBar = () => {



  return (
    <div>
        <nav className='header'>
            <ul className="header">
                <li><h1>TestTask</h1></li>
                <li> <NavLink className='project__nav' to="/">
                 <CalendarRange /> Проекты
                  </NavLink></li>
                <li>  <CalendarPlus />Создать</li>
                <li>  <Search /> Поиск</li>
            </ul>
        </nav>
    </div>
  )
}
